var nodes = require('./nodes');

function genericPrint(path, options, print) {
  var node = path.getValue();

  if (node === null) {
    return '';
  }

  if (!(node.type in nodes)) {
    throw new Error("Unknown type: ".concat(JSON.stringify(node.type)));
  }

  return nodes[node.type].print({
    node: node,
    options: options,
    path: path,
    print: print
  });
}

module.exports = genericPrint;